const doc = [({"se":({"js":({"components":({"user":({"admin":({"school_classes":({"index":({"user_circle":({"options_button":({})})})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;